/**
 * Select an integer representation for the number of replies
 */
Beef.module("ReplyCountPicker").addInitializer(function(startupOptions) {

    this.View = Beef.IntegerPicker.View.extend({
        attribute: 'Reply Count'
    });

    this.converter = Beef.IntegerPicker.createConverter("Number of Replies", "Reply count");

    this.attach = function(view, selector, attribute, options) {
        Beef.IntegerPicker.attachPicker(view, selector, attribute, this.View, options);
    };

});
